export default __webpack_public_path__ + "static/media/com-converse2.51f5c308.mp4";